import axios from "axios";
import { BASE_URL } from "./baseUrl";
import { getClientSource } from "./Functions";

async function fetchExpenseAttachmentBlob(expenseId, attachmentType) {
  const accessToken = localStorage.getItem("accessToken");
  const path =
    attachmentType === "invoice"
      ? `/api/finance/expenses/${expenseId}/invoice/view`
      : `/api/finance/expenses/${expenseId}/upi-screenshot/view`;

  const res = await axios.get(`${BASE_URL}${path}`, {
    responseType: "arraybuffer",
    headers: {
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      company_source: getClientSource(),
    },
    validateStatus: () => true,
  });

  if (res.status === 401) {
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }

  if (res.status !== 200) {
    throw new Error("Could not load the expense attachment.");
  }

  const contentType = res.headers["content-type"] || "application/octet-stream";
  return new Blob([res.data], { type: contentType });
}

export function fetchExpenseInvoiceBlob(expenseId) {
  return fetchExpenseAttachmentBlob(expenseId, "invoice");
}

export function fetchExpenseUpiScreenshotBlob(expenseId) {
  return fetchExpenseAttachmentBlob(expenseId, "upi-screenshot");
}
